// Central social config — edit handles/URLs here.
export const HANDLE = "@nordicvy.ca";

export const SOCIALS = [
  { name: "instagram", label: "Instagram", url: "https://instagram.com/nordicvy.ca" },
];

// Build share intent URLs (Instagram/TikTok have no web share intent).
export function shareLinks({ url, title, image }) {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  const img = encodeURIComponent(image || "");
  return [
    { name: "facebook", label: "Facebook", url: `https://www.facebook.com/sharer/sharer.php?u=${u}` },
    { name: "pinterest", label: "Pinterest", url: `https://pinterest.com/pin/create/button/?url=${u}&media=${img}&description=${t}` },
    { name: "twitter", label: "X", url: `https://twitter.com/intent/tweet?url=${u}&text=${t}` },
    { name: "whatsapp", label: "WhatsApp", url: `https://wa.me/?text=${t}%20${u}` },
  ];
}
